import React, { useState } from "react";
import { Typography, Paper, Divider } from "@mui/material";
import { ReactComponent as ArrowRight } from "../../assets/images/ArrowRight.svg";
import { ReactComponent as ArrowRightWhite } from "../../assets/images/ArrowRightWhite.svg";
import "../../styles/partCreation.css";
import CheckPartDialog from "./CheckPartDialog";
import axios from "axios";
import { automationHttpRequest } from "../../api/httpRequests";
import { ToastContainer, toast } from "react-toastify";

const CheckPartExtension = ({
  setCheckPartData,
  handleContinue,
  setExtension,
  showDecision,
  setExtensionData,
}) => {
  const [checkDialog, setCheckDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checkTableData, setCheckTableData] = useState([]);
  const [checkPart, setCheckPart] = useState({
    manufacturer: "",
    manufacturing_part_number: "",
    supplier_part_number: "",
  });

  const inputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
  };

  const inputStyleNext = {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    marginLeft: "30px",
  };

  const headingStyle = {
    fontWeight: "700",
  };

  const handleChange = (event) => {
    if (event?.target?.name === "manufacturer") {
      // event.target.value = event.target.value;
      setCheckPart((prevObject) => ({
        ...prevObject,
        manufacturer: event?.target?.value,
      }));
    }
    if (event?.target?.name === "manufacturingPartNumber") {
      setCheckPart((prevObject) => ({
        ...prevObject,
        manufacturing_part_number: event?.target?.value,
      }));
    }
    if (event?.target?.name === "supplierPartNumber") {
      setCheckPart((prevObject) => ({
        ...prevObject,
        supplier_part_number: event?.target?.value,
      }));
    }
  };

  const handleChangeNext = () => {
    setCheckDialog(true);
    fetchPartCheckResult();
    setCheckPartData(checkPart);
  };

  const fetchPartCheckResult = async () => {
    setLoading(true);
    const { supplier_part_number } = checkPart;
    const manufacturing_number = [];
    if (checkPart?.manufacturer.length > 0) {
      manufacturing_number.push(checkPart?.manufacturer);
    }
    if (checkPart?.manufacturing_part_number.length > 0) {
      manufacturing_number.push(checkPart?.manufacturing_part_number);
    }
    try {
      const response = await automationHttpRequest.post(
        "/existing_part_data/",
        {
          manufacturing_part_number: manufacturing_number,
          supplier_part_number,
        },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        }
      );
      if (response?.data?.status) {
        setCheckTableData(response?.data?.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  return (
    <>
      <Paper
        sx={{
          width: "100%",
          height: "150px",
          display: "flex",
          alignItems: "center",
          margin: "20px 0px",
          borderRadius: "18px",
        }}
        elevation={2}
      >
        {/* <div style={{width: "100%"}}>
          <div style={inputStyle}>
            <Typography style={headingStyle}>Preferred Supplier Identifier</Typography>
            <input
              value={checkPart.supplierIdentifier}
              //placeholder="Preferred Supplier Identifier"
              type="text"
              name="supplierIdentifier"
              onChange={handleChange}
              className="partInputFieldCreation"
            />
          </div>
          <Divider style={{margin: "20px"}} /> */}
        <div className="checkPart">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "baseline",
              marginTop: "6px",
            }}
          >
            <Typography style={headingStyle}>
              Manufacturer
              {/* \<span style={{color: "#C6003D", margin: "4px", fontSize: "20px"}}>*</span> */}
            </Typography>
            <input
              value={checkPart.manufacturer}
              //placeholder="Manufacturer"
              style={{ backgroundColor : "#FFFFFF !important"}}
              autoComplete="off"
              type="text"
              name="manufacturer"
              onChange={handleChange}
              className="partInputFieldCreation"
            />
          </div>
          <div style={inputStyle}>
            <Typography style={headingStyle}>
              Manufacturer Part Number{""}
              <span
                style={{ color: "#C6003D", margin: "4px", fontSize: "20px" }}
              >
                *
              </span>
            </Typography>
            <input
              value={checkPart.manufacturingPartNumber}
              //placeholder="manufacturing part number"
              type="text"
              name="manufacturingPartNumber"
                onChange={handleChange}
                autoComplete="off"
              className="partInputFieldCreation"
            />
          </div>
          <div style={inputStyle}>
            <Typography style={headingStyle}>
              Vendor Material Number
              <span
                style={{ color: "#C6003D", margin: "4px", fontSize: "20px" }}
              >
                *
              </span>
            </Typography>
            <input
              value={checkPart.supplierPartNumber}
              //placeholder="Vendort Part Number"
              type="text"
              autoComplete="off"
              name="supplierPartNumber"
              onChange={handleChange}
              className="partInputFieldCreation"
            />
          </div>
          {/* <div style={inputStyle}>
            <Typography style={headingStyle}>Description</Typography>
            <input
                value={checkPart.description}
              //placeholder="Description"
              type="text"
              name="description"
                onChange={handleChange}
              className="partInputFieldCreation"
            />
          </div> */}
          <div style={inputStyleNext}>
            <button
              className="checkbutton"
              style={{
                color:
                (checkPart?.manufacturing_part_number === "" ||
                checkPart?.supplier_part_number === "") || showDecision
                    ? "#C6003D"
                    : "#FFFFFF",
                background:
                (checkPart?.manufacturing_part_number === "" ||
                checkPart?.supplier_part_number === "") || showDecision
                    ? "#f5f5f5"
                    : "#C6003D",
                cursor:
                (checkPart?.manufacturing_part_number === "" ||
                  checkPart?.supplier_part_number === "") || showDecision
                    ? "default"
                    : "pointer",
              }}
              onClick={handleChangeNext}
              disabled={
             (checkPart?.manufacturing_part_number === "" ||
                checkPart?.supplier_part_number === "") || showDecision
              }
            >
              <span>Next</span>
              { (checkPart?.manufacturing_part_number === "" ||
                  checkPart?.supplier_part_number === "") || showDecision
                    ?  <ArrowRight />
                    : <ArrowRightWhite />}
            </button>
          </div>
        </div>
        {/* </div> */}
      </Paper>
      <CheckPartDialog
        checkDialog={checkDialog}
        setCheckDialog={setCheckDialog}
        loading={loading}
        checkTableData={checkTableData}
        handleContinue={handleContinue}
        setExtension={setExtension}
        setExtensionData={setExtensionData}
      />
    </>
  );
};

export default CheckPartExtension;
